import keycloakClient from "@keycloak/keycloak";
import { APIException } from "./api";

export const getAuthHeaders = (): { [header: string]: string } => {
  const headers = {
    Authorization: `Bearer ${keycloakClient.token}`,
    Accept: "application/json"
  };
  return headers;
};

export const handleAPIError = (error: any) => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const errorMessage = error.response.data.detail || error.response.data;
    throw new APIException(errorMessage, error.response.status);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    throw new APIException("Error getting summary", 500);
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new APIException(error.message, 500);
  }
};
